export default __webpack_public_path__ + "static/media/ai07.0b6ad398.png";